<template>
<div>
    <div class='glitchHolder'>
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div v-for="(g,gi) in glitches" :key="'g'+gi" class='glitchOver' :style="{marginBottom:g.pad+'px',width:g.width+'%'}">
        <div v-for="(gc,gci) in g.child" :key="'gc'+gci" class='glitchChild' :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"></div>
        </div>
      </div>
    </div>
    <v-container ma-0 pa-0 fluid> 
    <v-layout >
      <v-flex xs12 >
      <div id="colorBars" v-if="showBars">
        <div v-for="(bar,b) in colours" class='colorBar' :key="'bar'+b" :style="{backgroundColor:bar.colour,height:bar.height+'px',marginBottom:bar.pad+'px',width:bar.width+'%'}"></div>
      </div>
      
       <v-flex xs8 offset-xs2 >
        <v-carousel hide-delimiters  v-model="cModel" :cycle="cycle" :ref="'carousel'" :style="'height:'+vidHeight+'px;box-shadow:none;'" :interval="cinterval">
        <v-carousel-item   reverse-transition="fade-transition" transition="fade-transition">
            <video  id="video1" src="https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/content%2F-LRgQ1KTLH7S6kRdFRZb.mp4?alt=media&token=6aaf2f3e-9f2d-4792-8ef5-5d00b6e677cd"  
              poster="https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/content%2F-LRgQ1KTLH7S6kRdFRZb.png?alt=media&token=710663f1-1683-4c0f-b08c-100560b081ea" 
              width="100%" style="margin-top:10px;margin:auto;position:relative; width:100%;" 
              controls >
            </video> 
        </v-carousel-item>
        <v-carousel-item  v-if="false" reverse-transition="fade-transition" transition="fade-transition">
            <video id="video2" src="https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FSlowbart.mp4?alt=media&token=bdf7fdfc-b036-47aa-8784-ddefa8cd4533"  
              poster="https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2Fslowbart.png?alt=media&token=2ef0e16b-0101-4234-8e02-e7ef6b52be7c" 
              width="100%" style="margin-top:10px;margin:auto;position:relative; width:100%;background-color:#dedede;" 
              controls autoplay >
            </video>
            <div ><v-btn  style="position:absolute;top:5px;left:5px;font-size:20px;color:#807f7f;text-transform:lowercase;cursor:pointer" flat
                  
                  :to="'slowbart'">     
                slowbart program</v-btn>
            </div>
        </v-carousel-item>
        <v-carousel-item v-for="(img,i) in currentEventImages" :key="'img'+i">
      
            <v-img  :src="img.image" height="100%" width="100%" style="margin-top:10px;margin:auto;position:relative" @click="showBars=!showBars">
            <div  style="position:absolute;top:5px;left:5px;font-size:20px;color:#fff!important;background-color:#00000055;" 
                 >  
                  {{img.title}}   
               </div>
            </v-img> 
        </v-carousel-item> 
         <v-carousel-item v-if=" currentEvent && currentEvent.image">
      
            <v-img  :src="currentEvent.image" height="100%" width="100%" style="margin-top:10px;margin:auto;position:relative" @click="showBars=!showBars">
            <div  style="position:absolute;top:5px;left:5px;font-size:20px;color:#fff!important;background-color:#00000055;padding:0px 5px;" 
                 >     
                {{currentEvent.title}}</div>
            </v-img> 
        </v-carousel-item> 
      
      </v-carousel>
          <div v-for="(ce,i) in currentEvents" :key="'ce'+i"   style="display:flex; height:150px; ;margin-top:10px; position:relative;background-color:#eee;">   
            <div style="margin-right:10px">
              <img :src="ce.thumbnail"   height="100%" style="position:relative" > 
            </div>
            
            <div style="margin-left: 10px;">
              <div>
                <h3>{{ce["Home-Heading"]}}</h3>
                <h4 v-html="ce['Home-Details']"></h4>
              </div>
              <h4 v-if="ce.link" style="bottom:0px;"> <a :href="ce.link" target="blank">More Info</a> </h4>
              <h4 v-else style="bottom:0px;"> <a :href="'/events?'+ce.title" target="blank">More Info</a> </h4>
            </div>
          </div>
         
         
       
    </v-flex>
  </v-flex>
</v-layout>
      
<v-layout>
    <v-flex xs8 offset-xs2 pt-4 >
    <v-flex xs12 class="text-xs-center">
      <v-progress-circular indeterminate :size="50" 
      color="grey" 
      :width="7" 
      v-if="loading"></v-progress-circular>
      </v-flex>
     
    <div v-if="nowPlaying">
     <v-layout>

      <v-flex xs3 mr-2 v-if="previewImages.length>0">
          <div class="sub1">Now Playing</div>
           <div style="height:120px;overflow:hidden">
          <v-img v-if="this.nowPlaying" :src="this.nowPlaying.imageUrl"  height="180px" position="center -10px" @click="showBars=!showBars"  @mouseout="showBars=false"></v-img>
          </div>
          <div class=pTitle>{{this.nowPlaying.title}}</div>
      </v-flex>
      <v-flex xs3 ml-2 v-if="previewImages.length>1">
          <div class="sub1">Coming up</div>
           <div style="height:120px;overflow:hidden">
          <v-img v-if="this.nowPlaying" :src="previewImages[1].imageUrl"  height="180px" position="center -10px" @click="showBars=!showBars"  @mouseout="showBars=false"></v-img>
          </div>
          <div class=pTitle>{{previewImages[1].title}} </div>
      </v-flex>
      <v-flex xs3 ml-2 v-if="previewImages.length>2">
          <div class="sub1">&nbsp;</div>
          <div style="height:120px;overflow:hidden">
          <v-img v-if="this.nowPlaying" :src="previewImages[2].imageUrl" height="180px" position="center -10px" @click="showBars=!showBars"  @mouseout="showBars=false"></v-img>
          </div>
          <div class=pTitle>{{previewImages[2].title}}</div>
      </v-flex>
      <v-flex xs3 ml-2 v-if="previewImages.length>3">
          <div class="sub1">&nbsp;</div>
          <div style="height:120px;overflow:hidden">
          <v-img :src="previewImages[3].imageUrl"  height="180px" position="center -10px" @click="showBars=!showBars"  @mouseout="showBars=false"></v-img>
          </div>
          <div class=pTitle>{{previewImages[3].title}}</div>
      </v-flex>
     
    </v-layout> 
    </div>
     </v-flex>
    </v-layout>
    </v-container>
  
  </div>
</template>

<script>
import ScheduleView from './Content/ScheduleView.vue';
var vue
 export default {
   components: { ScheduleView },
   data () {
     return {
       cycle:true,
       cinterval:1000,
       cModel:1,
       video1:null,
       video2:null,
       window: {
      width: 0,
      height: 0,
    },
       trackInfo:[],
       prelaunch:false,
       lastPlaylistId:null,
        hasPlaying:false,
       plistIds:[],
       scheduleDisplay:null,
       nowPlaying:null,
       currentSchedule:null,
       lastTrack:null,
       currentTrack:null,
       showBars:false,
       colours:[{colour:'#231f20',height:17,name:"dark",pad:3,width:100},
       {colour:'#ea148c',height:17,name:"pink",pad:3,width:100},
       {colour:'#eb212e',height:36,name:"red",pad:3,width:100},
       {colour:'#8ec549',height:18,name:"green",pad:3,width:100},
       {colour:'#00afec',height:10,name:"blue",pad:3,width:100},
       {colour:'#ea148c',height:17,name:"pink",pad:3,width:100},
       {colour:'#eb212e',height:36,name:"red",pad:3,width:100},
       {colour:'#ea148c',height:18,name:"pink",pad:3,width:100},
       {colour:'#8ec549',height:26,name:"green",pad:3,width:100},
       {colour:'#00afec',height:10,name:"blue",pad:3,width:100}],
       glitches:null,
       glitchCount:20,
       glitchTop:200,
       previewImages:[]
     }
   },
   mounted(){
      
      
       this.$store.dispatch("loadEventsStatus")
     //this.$store.dispatch('loadStatus');
      console.log("MOUNTED",this.status)
      vue=this
      var self=this
      this.date=new Date().toISOString().substr(0, 10);
      this.glitches=[]
      var childA=[]
      
      for(var i=0;i<6;i++){
        childA=[]
        for(var p=0;p<2;p++){
          childA.push(Math.floor(Math.random()*100));
           
        }
        this.glitches.push({colour:'#00000044',height:30,pad:3,width:Math.random()*50+50,child:childA})

      }
      setInterval(this.glitchColour,100);
      setTimeout(this.glitch,150);
    this.video1 = document.getElementById('video1');
   if(this.video1){
     this.video1.addEventListener('ended',myHandler,false);
     this.video1.addEventListener('playing',vidStart,false);
   }
    this.video2 = document.getElementById('video2');
     if(this.video2){
    this.video2.addEventListener('playing',vidStart,false);
    this.video2.addEventListener('ended',myHandler,false);
     }
     //this.cycle=false
    function myHandler(e) {
      
       if(vue.video1.currentTime>0){
           vue.video1.load();
        }
        if(vue.video2 && vue.video2.currentTime>0){
           vue.video2.load();
        }
       vue.cycle=true
    }
    function vidStart(){
     
      vue.cycle=false
    }
    this.doStatus(this.status)
   },
   created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
   computed: {
     currentEventImages(){
       let images=[]
       for(var i in this.currentEvents){
         if(this.currentEvents[i].image){
           images.push({image:this.currentEvents[i].image,title:this.currentEvents[i].title})
         }
       }
       return images
     },
     currentEvent(){
       return this.$store.getters.getCurrentEvent
     },
     currentEvents(){
       return this.$store.getters.getCurrentEvents
     },
     vidHeight(){
       return this.window.width/12*8*9/16
     },
     vidWidth(){
       return this.window.width/12*8
     },
     randomPad(){
       return Math.floor(Math.random()*5+1)+"px"
     },
      hasStatus(){
        return this.$store.getters.getStatus !=null;
      },
      status () {
       
       return this.$store.getters.getStatus
     },
     tracks () {
       
       return this.$store.getters.getTracks
     },
     trackIndex(){
       if(status){
        return status.active
       }else{
         return null
       }
     },
     schedules () {
      
       return this.$store.getters.loadedSchedules
     },
     loading () {
       return this.$store.getters.loading
     },
     userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
     
    
    },
  
  watch:{ status(status){
     this.doStatus(status)
    },
      cModel(){
        console.log(this.cModel)
        this.cinterval=5000
       if(this.cModel==0 ){
         if(this.video2){
           this.video2.pause()
         }
        if(this.video1.currentTime>0){
          this.video1.load();
        }
       }
         if(this.cModel==1){
            this.video1.pause()
          if(this.video2 && this.video2.currentTime>0){
            this.video2.load();
          }else if(this.video2){
              this.video2.play()
          
          }
         }
        
        
      }

  },
   methods: {
    goto(link) {
      this.$router.push(link);
    },

     handleResize() {
      this.window.width = window.innerWidth;
      
    },
     glitch(){
        this.glitchCount++
        if(this.glitchCount>50){
            this.glitchCount=Math.random()*20-10
            this.glitchTop=Math.random()*400+100;
        }
       if(this.glitchCount>10){
         this.glitchCount+=Math.random()*40
          setTimeout(this.glitch,Math.random()*100+100);
          return
       }
        for(var g in this.glitches){
          if(Math.random()*10>7){
            this.glitches[g].height=Math.random()*20+5;
            for(var gc in this.glitches[g].child){
                this.glitches[g].child[gc]=Math.floor(Math.random()*160+20);
            }
             if(Math.random()*10>5){
               this.glitches[g].height=0;
             }
          }
          this.glitches[g].pad=Math.floor(Math.random()*5+5)
          this.glitches[g].width=Math.floor(Math.random()*160+20) 
        }
        if(Math.random()*10>5){
         // this.glitchTop=Math.random()*400+100;
        }
        setTimeout(this.glitch,100);
     },
     glitchColour(){
        for(var i in this.colours){
          if(Math.random()*10>7){
          this.colours[i].height=Math.random()*20+5;
          }
          this.colours[i].pad=Math.floor(Math.random()*5+1)
          if(Math.random()*10>9 && i>0){
          this.colours[i].width=100-Math.floor(Math.random()*20)
          }else{
             this.colours[i].width=100
          }
        }      
     },
     getItem(index){
      console.log(this.currentSchedule.items[index])
       if(this.currentSchedule.items[index] && this.currentSchedule.items[index].title!="The Loop"){
        return this.getContent(this.currentSchedule.items[index].id);
       }else{
         return null
       }
     },
     
     allowedDates(val){
            parseInt(val.split('-')[2], 10) % 2 === 0
        },
     playlistInfo(playlist){
       this.plistIds.push(playlist.id)
       if( this.plistIds.length>1 && this.plistIds[ this.plistIds.length-1]==this.plistIds[ this.plistIds.length-2]){
         //this.lastPlaylistId=playlist.id;
         return null;
       }else{
         return "[ "+playlist.name+" ]"
       }
     },
     

     showSchedule (id){
       console.log("SHOW",id);
     },
     
     
     getContent(id){
       //console.log("GET CONTENT",id)
       // console.log(this.$store.getters.loadedContent(id));
              return this.$store.getters.loadedContent(id)
    },
    getPlaylist(id){
      
      return this.$store.getters.loadedPlaylist(id)
    },
    secondsToDuration(sec){
        var hrs=Math.floor(sec/(60*60));
        var mins=Math.floor((sec-hrs*60*60)/60);
        var secs=Math.floor(sec%60);
        if(hrs<10){hrs="0"+hrs}
        if(mins<10){mins="0"+mins}
        if(secs<10){secs="0"+secs}
        return hrs+":"+mins+":"+secs
      },
      doStatus(status){
        if(!status){
          return
        }
       //console.log("Watch status",this.currentTrack,status);
      
      this.currentTrack=(status.active)-2;
      if(this.currentTrack!=this.lastTrack ){
        console.log("GET SCHEDULE",status.schedule)
        this.currentSchedule=this.$store.getters.loadedSchedule(status.schedule)
        this.lastTrack=this.currentTrack;
        var key=this.tracks.tracks[this.currentTrack-1].split('.')[0];
        console.log("KEY",key,this.$store.getters.loadedContent(key) )
        if(key.substr(0,1)=="-"){
          this.nowPlaying = this.$store.getters.loadedContent(key) 
        }else{
          if(this.currentSchedule.items.length>0 && key!="Colour"){
            this.nowPlaying = this.getContent(this.currentSchedule.items[this.currentTrack].id);       
     
          }
            }
        console.log("this.nowPlaying",this.nowPlaying)
        //
        var item
        var index=this.currentTrack;
        var found=0;
        //console.log("STATUS index",index,this.currentSchedule.items.length)
        this.previewImages=[];
        while(index<this.currentSchedule.items.length && found<4){
          
          item=this.getItem(index);
          console.log("XXXX",index,item);
          if(item){
            console.log("XXXX",item,item.imageUrl);
          }
         
          if(item && item.imageUrl && item.title!="The Loop logo"){

            found++;
            this.previewImages.push(item);
          }
          index++;
        }
        
      }
    }
   }
 }
</script>
<style>
.v-carousel__prev .v-btn i, .v-carousel__next .v-btn i {
    color: #a2a2a2!important;
    font-size: 48px;
}
</style>
<style scoped>
video{
  background: url(' ;https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/content%2F-LRgQ1KTLH7S6kRdFRZb.png?alt=media&token=710663f1-1683-4c0f-b08c-100560b081ea')
  
}
.v-text-field {
    padding-top: 0px;
    margin-top:0px;
    
}
  .title{
    position:absolute;
    bottom:50px;
    background-color:rgba(0,0,0,0.5);
    color:#fff;
    padding:5px;
    font-size:2em;
  }
  .screen {
    margin:auto;
    top:30%;
    background-color: #f7f7f7;
    width: 64%;
    padding-top: 40%; /* 1:1 Aspect Ratio */
    position: relative; /* If you want text inside of it */
    box-shadow: black 0px 0px 50px 0px;
}

/* If you want text inside of the container */
.screentext {
    
    position: absolute;
    top: 35%;
    left: 0;
    bottom: 0;
    right: 0;
    font-size: 20px;
    font-weight: 700;
    color: #7f7f7f;
    text-shadow: #00000033 0px 0px 20px;
}
.titlePreview{
  position:relative;
  width:64%;
  padding-top:40%;
  height:100%;
  background-color:#000;
  color:#fff;
  margin: auto;
  text-align: center;
  position:relative;
}
.titlePreview .pTitle{
  position: absolute;
  width:100%;
  top:5%;
  font-size:70%;
}
.titlePreview .pSubtitle{
  position: absolute;
  width:100%;
  top:10%;
  font-size:40%;
}
.titlePreview .pBody{
  position: absolute;
  top:20%;
  width:100%;
  font-size:40%;
}
.titlePreview .pFooter{
  text-align: center;
  width:100%;
  position: absolute;
  bottom:5%;
  font-size:40%;
}
#colorBars{
  position:absolute;
  
  width:100%;
 
}
.colorBar{
  position:relative;
  min-height:10px;
  margin:auto;
  margin-bottom:5px;
}
.sub1{
  text-transform:uppercase;
  min-height:12px;
  font-size:12;
  font-weight:500;
}
.glitchHolder{
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    pointer-events: none;
  }
  #glitchOverlay{
  position:absolute;
  left:-100px;
  top:300px;
}
.glitchOver{
  
  z-index:3;
  position:relative;
  min-height:30px;
  pointer-events:none;
  opacity:0.3;
  width:400px;
  
}
.glitchChild{
  width:40px;
  display:inline-block;
  background-color:#00f;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue